import { RentalDurationPolicyConfig } from '../interfaces/rental-duration-policy-config.interface';

/**
 * Resolves rental-duration apply config from a policy record.
 * No record → null (min-1 ceil path). Record present → config or {} (round/threshold path).
 */
export function resolveRentalDurationPolicyConfig(
	policyRecord: { config?: unknown } | null | undefined,
): RentalDurationPolicyConfig | null {
	if (!policyRecord) {
		return null;
	}

	return (policyRecord.config as RentalDurationPolicyConfig) ?? {};
}
